var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('permissions-checkbox',_vm._b({model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'permissions-checkbox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }